/**
 * (配車スケジュール 新規登録/詳細) 日時＆回収予定日関連Script関数ファイル
 */

/* Import Modules */
import $ from "jquery";

/* Define Script */
// 日時 開始時間/終了時間項 有効/無効 設定
export const disableScheduleDate = (scheduleTimePeriodId: number) => {
  switch (true) {
    case scheduleTimePeriodId == 1:
      // まで
      $("#date").prop("readonly", false); // 日付項 有効化
      $("#start_time").prop("readonly", false); // 開始時間項 有効化
      $("#end_time").prop("readonly", true); // 終了時間項 無効化
      break;
    case scheduleTimePeriodId == 2:
      // 時丁度
      $("#date").prop("readonly", false); // 日付項 有効化
      $("#start_time").prop("readonly", false); // 開始時間項 有効化
      $("#end_time").prop("readonly", true); // 終了時間項 無効化
      break;
    case scheduleTimePeriodId == 3:
      // なる早
      $("#date").prop("readonly", false); // 日付項 有効化
      $("#start_time").prop("readonly", true); // 開始時間項 無効化
      $("#end_time").prop("readonly", true); // 終了時間項 無効化
      break;
    case scheduleTimePeriodId == 4:
      // 終日
      $("#date").prop("readonly", false); // 日付項 有効化
      $("#start_time").prop("readonly", true); // 開始時間項 無効化
      $("#end_time").prop("readonly", true); // 終了時間項 無効化
      break;
    case scheduleTimePeriodId == 5:
      // 表示なし
      $("#date").prop("readonly", false); // 日付項 有効化
      $("#start_time").prop("readonly", false); // 開始時間項 有効化
      $("#end_time").prop("readonly", false); // 終了時間項 有効化
      break;
    case scheduleTimePeriodId == 6:
      // 連絡待ち
      $("#date").prop("readonly", false); // 日付項 有効化
      $("#start_time").prop("readonly", true); // 開始時間項 無効化
      $("#end_time").prop("readonly", true); // 終了時間項 無効化
      break;
    default: // 日付項 有効化
      // 開始時間項 有効化
      // 該当なしの場合、すべて有効化とする
      $("#date").prop("readonly", false);
      $("#start_time").prop("readonly", false);
      $("#end_time").prop("readonly", false); // 終了時間項 有効化
  }
};

/* trigger */
export const eventFiringByScheduleEdit = () => {
  // 日時
  $("input:radio[name=schedule_time_period_id]:checked").change();
};

/**
 * グローバル関数を定義
 */
(window as any).disableScheduleDate = disableScheduleDate;
(window as any).eventFiringByScheduleEdit = eventFiringByScheduleEdit;
